module.exports = __webpack_public_path__ + "static/media/24UHCHR11.473e2b66.jpg";